<template>
  <div
    class="custom-tooltip"
    :class="{ 'custom-tooltip--block': block }"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
    @focusin="onEnter"
    @focusout="onLeave"
  >
    <div class="custom-tooltip__trigger">
      <slot />
    </div>
    <transition name="custom-tooltip-pop">
      <div
        v-show="open && effectiveText"
        :id="tooltipId"
        class="custom-tooltip__panel"
        role="tooltip"
      >
        <span class="custom-tooltip__text">{{ effectiveText }}</span>
        <span
          class="custom-tooltip__arrow"
          aria-hidden="true"
        />
      </div>
    </transition>
  </div>
</template>

<script>
let tooltipUid = 0;

export default {
  name: 'CustomTooltip',
  props: {
    /** Texto exibido no tooltip. Vazio = não mostra painel. */
    text: {
      type: String,
      default: '',
    },
    /** Desativa o tooltip mesmo com texto. */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Ocupa largura total (ex.: linhas de lista). */
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
      tooltipId: `custom-tooltip-${tooltipUid += 1}`,
    };
  },
  computed: {
    effectiveText() {
      if (this.disabled) return '';
      const t = (this.text || '').trim();
      return t;
    },
  },
  methods: {
    onEnter() {
      if (!this.effectiveText) return;
      this.open = true;
    },
    onLeave() {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tooltip {
  position: relative;
  display: inline-block;

  &--block {
    display: block;
    width: 100%;
  }

  &__trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &--block &__trigger {
    display: block;
    width: 100%;
  }

  &__panel {
    position: absolute;
    z-index: 200;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    min-width: max-content;
    max-width: 280px;
    padding: 10px 14px;
    background-color: $color_dark;
    color: $color_light;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.35;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
    pointer-events: none;
  }

  &__text {
    display: block;
    white-space: pre-line;
    word-break: break-word;
  }

  &__arrow {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 0;
    height: 0;
    margin-left: -7px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid $color_dark;
  }
}

.custom-tooltip-pop-enter-active,
.custom-tooltip-pop-leave-active {
  transition: opacity 0.18s ease;
}

.custom-tooltip-pop-enter,
.custom-tooltip-pop-leave-to {
  opacity: 0;
}

.custom-tooltip-pop-enter-to,
.custom-tooltip-pop-leave {
  opacity: 1;
}
</style>
